const languages = [
  { id: 1, name: "Malayalam", read: true, write: true, speak: true },
  { id: 2, name: "English", read: true, write: true, speak: true },
  { id: 3, name: "Tamil", read: true, write: false, speak: true },
  { id: 4, name: "Hindi", read: true, write: false, speak: true },
];

export default languages;
